// The X logo, in the shape Font Awesome icons take, so it can be used with
// <FontAwesomeIcon> like the other social icons. The site's Font Awesome
// (5.15) is older than the X logo, which arrived in 6.4.2; this is that
// version's "x-twitter" drawing (Font Awesome Free, CC BY 4.0).
export const faXTwitter = {
  prefix: 'fab',
  iconName: 'x-twitter',
  icon: [
    512, 512, [], 'e61b',
    'M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z',
  ],
};
